<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26.29 7.05l-6.5-2a1.06 1.06 0 00-.56 0L12.51 7 6.29 5A1 1 0 005 6v18a1 1 0 00.71 1l6.5 2a1.06 1.06 0 00.56 0l6.72-2 6.22 2A1 1 0 0027 26V8a1 1 0 00-.71-.95zM13 8.9l6-1.72V23.1l-6 1.72zM7 7.35l5 1.54V24.8l-5-1.54zm13 15.76V7.2l5 1.54v15.91z"/></svg>